import styled from 'styled-components/native'
import { colors } from 'infra/color'
import { DEFAULT_FONT_FAMILY } from 'ui/common/text'

export const CustomTextInput = styled.TextInput.attrs({
  cursorColor: colors.gray.v700,
  selectionColor: colors.primary,
  placeholderTextColor: colors.gray.v500,
})`
  font-family: ${DEFAULT_FONT_FAMILY};
  color: ${colors.black};
`
